module.exports = __webpack_public_path__ + "img/worth_4.290e029b.png";